import { AbstractStepController, AppClientConfigurationService, FlowStepHandleResult, HandleResultType, StepControl, StepControlType, WizardServiceLocator } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

export class VisitorCreateRegistrationQRCodeController extends AbstractStepController {

  private cps: AppClientConfigurationService;

  private timer: any;

  private targetProcessFlowOnFinish: string;

  constructor() {
    super();
    this.cps = WizardServiceLocator.injector.get(AppClientConfigurationService);
  }

  onRegisterToDashboardContext() {
    this.targetProcessFlowOnFinish = this.wizardComponent.currentStep.dashboardConfiguration?.cancelProcessFlow;
  }

  onContextChange(contextChange: ContextChange) {
  }

  handleFlow(): FlowStepHandleResult {

    this.timer = setTimeout(() => {
      this.finish();
    }, parseInt(this.cps.getPropertyValue('tmc-yard.terminal.summary-timer', '60')) * 1000);

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const finishControl = new StepControl();
    finishControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.visitor-registration-summary.button.finish';
    finishControl.type = StepControlType.BUTTON;
    finishControl.controlAction = this.finish.bind(this);
    controls.push(finishControl);

    return controls;
  }

  private finish() {
    clearTimeout(this.timer);
    this.wizardComponent.restartWizard();
  }
}
